/** @jsx h */
import { h } from 'preact'
import Icon from './icons/icons'
import { useState, useRef, Fragment } from 'preact/compat'
import clsx from 'clsx'
import useClickOutside from '../use-click-outside'
import dayjs from 'dayjs'

const InputItem = ({ isSelected, onChange, name, value }) => {
  return (
    <button
      onClick={e => onChange(value)}
      type='button'
      aria-pressed={isSelected}
      className={clsx(
        'rcc_c_available-time-item rcc-text-center rcc-text-sm rcc-font-normal rcc-bg-transparent hover:rcc-outline hover:rcc-outline-1',
        {
          'rcc-outline rcc-outline-1': isSelected,
          'rcc-text-text': !isSelected
        }
      )}
    >
      {name}
    </button>
  )
}

const InputTime = ({
  id,
  className,
  hasError,
  date,
  slots,
  name,
  label,
  errorLabel,
  required = false,
  value,
  onChange,
  direction,
  placeholder
}) => {
  const ref = useRef()
  const [open, setOpen] = useState(false)
  const [selectedSlot, setSelectedSlot] = useState(value)

  useClickOutside(ref, () => {
    setOpen(false)
  })

  const fullDateValue = value ? new Date(new Date().toISOString().substring(0, 11) + value) : null

  const formatTime = time => {
    if (dayjs.locale() === 'ar') {
      return dayjs(time).format('hh:mm a')
    }

    return dayjs(time).format('LT')
  }

  return (
    <Fragment>
      <div ref={ref} className={`rcc-relative rcc-text-text ${className}`}>
        <label
          htmlFor={id}
          className={clsx('rcc-text-sm rcc-block rcc-mb-2.5', {
            'rcc-text-gray': !hasError,
            'rcc-text-danger': hasError,
            'rcc-text-right': direction === 'rtl'
          })}
        >
          {label}
        </label>

        <div
          className={clsx('rcc-flex rcc-items-center rcc-border rcc-border-solid', {
            'rcc-border-danger': hasError,
            'rcc-border-gray-light': !hasError,
            'rcc-flex-row-reverse': direction === 'rtl'
          })}
        >
          <div
            className={clsx('rcc-self-stretch rcc-flex rcc-items-center rcc-px-4 rcc-border-r rcc-border-gray-light', {
              'rcc-border-l rcc-border-r-0': direction === 'rtl'
            })}
          >
            <Icon name='time' className='rcc_c_input-icon' />
          </div>
          <input
            id={id}
            onClick={() => setOpen(prev => !prev)}
            value={fullDateValue ? formatTime(fullDateValue) : placeholder}
            className={clsx(
              'rcc-text-text rcc-h-[50px] rcc-flex-1 rcc-pl-5 rcc-pr-8 rcc-bg-transparent rcc-cursor-pointer',
              {
                'rcc-text-right': direction === 'rtl',
                'rcc-text-left': direction === 'ltr'
              }
            )}
            type='button'
            name='inputTime'
            required={required}
            disabled={!date?.length}
            readOnly
            aria-label='Toggle available time'
          ></input>

          <div
            className={clsx('rcc-flex rcc-items-center rcc-px-5 rcc-absolute rcc-h-[50px] rcc-right-0 rcc-z-[-1]', {
              'rcc-left-0 rcc-right-[unset]': direction === 'rtl'
            })}
          >
            <Icon name='arrow-next' className='rcc-pointer-events-none rcc-rotate-90' />
          </div>
        </div>

        {open && (
          <div
            className={clsx('rcc_c_available-time', {
              rcc_grid_rtl: direction === 'rtl'
            })}
          >
            {slots.map((slot, index) => {
              const fullFakeDate = new Date(new Date().toISOString().substring(0, 11) + slot.startT.substring(0, 5))
              const label = formatTime(fullFakeDate)
              const value = slot.startT.substring(0, 5)
              return (
                <InputItem
                  key={index}
                  name={label}
                  value={value}
                  isSelected={selectedSlot === value}
                  onChange={slot => {
                    setSelectedSlot(slot)
                    onChange(slot)
                    setOpen(false)
                  }}
                />
              )
            })}
          </div>
        )}
      </div>
      {hasError && errorLabel && <span className='rcc-text-danger rcc-mt-1'>{errorLabel}</span>}
    </Fragment>
  )
}

export default InputTime
